import React from 'react'
import PropTypes from 'prop-types'
import { css } from 'linaria'
import { FullLoading } from '@hb/web-components'

// FullLoading centers only inside a parent with a height. The done page has no layout around it (#root has only a
// min-height), so its loader sat at the top edge (QA 2026-10-02): `fullscreen` centers it in the viewport.
const fullscreenStyles = css`
  @apply flex min-h-screen items-center justify-center;
`

const Loading = ({ fullscreen }) => (fullscreen
  ? <div className={fullscreenStyles}><FullLoading /></div>
  : <FullLoading fullscreen key="full-loading" />)

Loading.propTypes = {
  fullscreen: PropTypes.bool,
}

Loading.defaultProps = {
  fullscreen: false,
}

export default Loading
